/* eslint-disable react/prop-types */
import React, { FC, useContext } from 'react';
import { T } from '@sm/intl';
import { StaticContext } from '@sm/webassets';
import useStyles from './useStyles';

// TODO: Wrap in defineMessages when ready for translations
const DEFAULT_COPY = {
  PRIVACY: {
    id: 'FooterPrivacyAndCookiePolicy.Privacy',
    defaultMessage: 'Privacy',
    description: '[Type: Link][Vis: high] - Privacy anchor element',
  },
  COOKIE_POLICY: {
    id: 'FooterPrivacyAndCookiePolicy.CookiePolicy',
    defaultMessage: 'Cookie Policy',
    description: '[Type: Link][Vis: high] - Cookie policy anchor element',
  },
  REPORT: {
    id: 'FooterPrivacyAndCookiePolicy.Report',
    defaultMessage: 'Report a problem with this survey',
    description: '[Type: Link][Vis: high] - Report a problem anchor element',
  },
};

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface FooterPrivacyAndCookiePolicyProps {
  /** Boolean to determine if we show the 'report a problem with this survey' anchor element */
  showReportProblem: boolean;
  /** URL for the report problem anchor element */
  reportProblemURL: string;
}

const FooterPrivacyAndCookiePolicy: FC<FooterPrivacyAndCookiePolicyProps> = ({
  reportProblemURL,
  showReportProblem,
}) => {
  const {
    environment: { domain, subdomain, tld },
  } = useContext(StaticContext);

  const CURRENT_DOMAIN_URL = `https://${subdomain}.${domain}.${tld}`;
  const COOKIE_POLICY_URL = `${CURRENT_DOMAIN_URL}/mp/legal/cookies/?ut_source=survey_pp`;
  const PRIVACY_POLICY_URL = `${CURRENT_DOMAIN_URL}/mp/legal/privacy-basics/?ut_source=survey_pp`;

  const { text, reportContainer } = useStyles();
  return (
    <>
      <p className={text}>
        <a
          className={text}
          rel="noreferrer"
          target="_blank"
          href={PRIVACY_POLICY_URL}
          data-testid="FooterPrivacyAndCookiePolicy__Privacy"
        >
          <T desc={DEFAULT_COPY.PRIVACY} />
        </a>{' '}
        &{' '}
        <a
          className={text}
          rel="noreferrer"
          target="_blank"
          href={COOKIE_POLICY_URL}
          data-testid="FooterPrivacyAndCookiePolicy__Cookie"
        >
          <T desc={DEFAULT_COPY.COOKIE_POLICY} />
        </a>
      </p>
      {showReportProblem && (
        <div className={reportContainer}>
          <span aria-hidden>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <a href={reportProblemURL} className={text}>
            <T desc={DEFAULT_COPY.REPORT} />
          </a>
        </div>
      )}
    </>
  );
};

export default FooterPrivacyAndCookiePolicy;
